var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76303 13.9732C7.07646 13.8242 7.20775 13.4516 7.05789 13.1399C6.14634 11.2311 6.53978 8.9429 8.03575 7.44694C9.98572 5.49696 13.1585 5.49652 15.1089 7.44694C16.6048 8.9429 16.9983 11.2311 16.0867 13.1399C15.9373 13.4511 16.0691 13.8242 16.3807 13.9732C16.6919 14.1218 17.0655 13.9905 17.214 13.6784C18.3541 11.2925 17.8634 8.4332 15.993 6.5628C13.5554 4.12522 9.58919 4.12522 7.15161 6.5628C5.28121 8.4332 4.79007 11.2921 5.93017 13.6788C6.0787 13.99 6.45137 14.1222 6.76303 13.9732ZM11.5723 12.7515L14.1933 15.3725C12.6456 16.5312 10.4994 16.5317 8.95124 15.3725L11.5723 12.7515ZM15.5509 15.846C15.7949 15.602 15.7953 15.2063 15.5509 14.9619L12.0143 11.4253C11.7699 11.1808 11.3742 11.1813 11.1302 11.4253L7.59361 14.9619C7.34959 15.2059 7.34915 15.6016 7.59361 15.846C9.78761 18.04 13.3573 18.0396 15.5509 15.846Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieIcon);
export default __webpack_public_path__ + "static/media/pie-icon.ee93a44e.svg";
export { ForwardRef as ReactComponent };